import img1 from "../assets/cave/spider-row.png";
import img2 from "../assets/cave/bats-row.png";
import img3 from "../assets/cave/wolf-row.png";
import img4 from "../assets/main/send-button.png";
import img5 from "../assets/cave/backend-info.png";
import img6 from "../assets/cave/devops-info.png";
import img7 from "../assets/cave/frontend-info.png";
import img8 from "../assets/main/main-character-row.png";
import img9 from "../assets/warrior/warrior-row.png";
import img10 from "../assets/mage/mage-row.png";
import img11 from "../assets/hunter/hunter-row.png";
import img12 from "../assets/main/character-change-row.png";
import img13 from "../assets/warrior/warrior-card.png";
import img14 from "../assets/mage/mage-card.png";
import img15 from "../assets/hunter/hunter-card.png";
import img16 from "../assets/main/mobile/mobile-move-left.png";
import img17 from "../assets/main/mobile/mobile-move-right.png";
import img18 from "../assets/ground/florest/floor.png";
import img19 from "../assets/ground/cave/floor.png";
import img20 from "../assets/ground/cave/sub-floor.png";
import img21 from "../assets/ground/sea/floor.png";
import img22 from "../assets/ground/sea/left-sand.png";
import img23 from "../assets/ground/sea/water.png";
import img24 from "../assets/ground/island/left-island-floor.png";
import img25 from "../assets/ground/sea/top-floor.png";
import img26 from "../assets/ground/island/floor.png";
import img27 from "../assets/ground/island/waves.png";
import img28 from "../assets/hunter/hunter-attack-button.png";
import img29 from "../assets/mage/mage-attack-button.png";
import img30 from "../assets/warrior/warrior-attack-button.png";
import img31 from "../assets/main/wait-message.png";
import img32 from "../assets/main/invalid-email-message.png";
import img33 from "../assets/main/empty-fields-message.png";
import img34 from "../assets/main/error-message.png";
import img35 from "../assets/main/success-message.png";
import img36 from "../assets/cave/ceiling-mid.png";
import img37 from "../assets/cave/ceiling-front.png";
import img38 from "../assets/cave/rock.png";
import img39 from "../assets/cave/soft-hard-sign.png";
import img40 from "../assets/cave/animals-sign.png";
import img41 from "../assets/cave/ceiling-back.png";
import img42 from "../assets/cave/left-door.png";
import img43 from "../assets/cave/right-door.png";
import img44 from "../assets/cave/out-left-back.png";
import img45 from "../assets/cave/out-right-back.png";
import img46 from "../assets/cave/out-left-front.png";
import img47 from "../assets/cave/out-right-front.png";
import img48 from "../assets/cave/mobile/out-left-front.png";
import img49 from "../assets/cave/mobile/out-right-front.png";
import img50 from "../assets/florest/tree-1.png";
import img51 from "../assets/florest/tree-2.png";
import img52 from "../assets/florest/tree-3.png";
import img53 from "../assets/florest/tree-4.png";
import img54 from "../assets/florest/mountain-1.png";
import img55 from "../assets/florest/mountain-2.png";
import img56 from "../assets/florest/mountain-3.png";
import img57 from "../assets/florest/mountain-4.png";
import img58 from "../assets/florest/mountain-5.png";
import img59 from "../assets/florest/mountain-6.png";
import img60 from "../assets/florest/backmountain-1.png";
import img61 from "../assets/florest/backmountain-2.png";
import img62 from "../assets/florest/backmountain-3.png";
import img63 from "../assets/florest/backmountain-4.png";
import img64 from "../assets/florest/moon.png";
import img65 from "../assets/florest/star-1.png";
import img66 from "../assets/florest/star-2.png";
import img67 from "../assets/florest/star-3.png";
import img68 from "../assets/florest/star-4.png";
import img69 from "../assets/florest/star-5.png";
import img70 from "../assets/florest/star-6.png";
import img71 from "../assets/florest/star-7.png";
import img72 from "../assets/florest/star-8.png";
import img73 from "../assets/florest/star-9.png";
import img74 from "../assets/florest/star-11.png";
import img75 from "../assets/florest/fog-1.png";
import img76 from "../assets/florest/fog-2.png";
import img77 from "../assets/florest/fog-3.png";
import img78 from "../assets/florest/fog-4.png";
import img79 from "../assets/florest/fog-5.png";
import img80 from "../assets/florest/scroll-sign.png";
import img81 from "../assets/florest/soft-skills-sign.png";
import img82 from "../assets/florest/star-13.png";
import img83 from "../assets/florest/star-12.png";
import img84 from "../assets/florest/star-10.png";
import img85 from "../assets/florest/class-sign.png";
import img86 from "../assets/island/guitarplayer-row.png";
import img87 from "../assets/island/magicbook-row.png";
import img88 from "../assets/island/chest-row.png";
import img89 from "../assets/island/vulcan.png";
import img90 from "../assets/island/mountain-2.png";
import img91 from "../assets/island/mountain-3.png";
import img92 from "../assets/island/mountain-1.png";
import img93 from "../assets/island/mountain-5.png";
import img94 from "../assets/island/mountain-4.png";
import img95 from "../assets/island/back-grass.png";
import img96 from "../assets/island/front-grass.png";
import img97 from "../assets/island/rock-1.png";
import img98 from "../assets/island/rock-2.png";
import img99 from "../assets/island/bush-1.png";
import img100 from "../assets/island/bush-2.png";
import img101 from "../assets/island/bush-3.png";
import img102 from "../assets/island/sec-exp-sign.png";
import img103 from "../assets/island/experience-sign.png";
import img104 from "../assets/island/dragon-sign.png";
import img105 from "../assets/sea/surfer-row.png";
import img106 from "../assets/sea/sun.png";
import img107 from "../assets/sea/cloud-1.png";
import img108 from "../assets/sea/cloud-2.png";
import img109 from "../assets/sea/cloud-3.png";
import img110 from "../assets/sea/cloud-4.png";
import img111 from "../assets/sea/cloud-5.png";
import img112 from "../assets/sea/cloud-6.png";
import img113 from "../assets/sea/cloud-7.png";
import img114 from "../assets/sea/palmtree-1.png";
import img115 from "../assets/sea/palmtree-2.png";
import img116 from "../assets/sea/background-trees.png";
import img117 from "../assets/sea/back-wave.png";
import img118 from "../assets/sea/palmtree-big-1.png";
import img119 from "../assets/sea/palmtree-big-2.png";
import img120 from "../assets/sea/mid-wave.png";
import img121 from "../assets/sea/boat-sail.png";
import img122 from "../assets/sea/boat.png";
import img123 from "../assets/sea/front-wave.png";
import img124 from "../assets/sea/hard-sec-sign.png";
import img125 from "../assets/cave/backend-info-small-screen.png";

const imageSrcs = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  img25,
  img26,
  img27,
  img28,
  img29,
  img30,
  img31,
  img32,
  img33,
  img34,
  img35,
  img36,
  img37,
  img38,
  img39,
  img40,
  img41,
  img42,
  img43,
  img44,
  img45,
  img46,
  img47,
  img48,
  img49,
  img50,
  img51,
  img52,
  img53,
  img54,
  img55,
  img56,
  img57,
  img58,
  img59,
  img60,
  img61,
  img62,
  img63,
  img64,
  img65,
  img66,
  img67,
  img68,
  img69,
  img70,
  img71,
  img72,
  img73,
  img74,
  img75,
  img76,
  img77,
  img78,
  img79,
  img80,
  img81,
  img82,
  img83,
  img84,
  img85,
  img86,
  img87,
  img88,
  img89,
  img90,
  img91,
  img92,
  img93,
  img94,
  img95,
  img96,
  img97,
  img98,
  img99,
  img100,
  img101,
  img102,
  img103,
  img104,
  img105,
  img106,
  img107,
  img108,
  img109,
  img110,
  img111,
  img112,
  img113,
  img114,
  img115,
  img116,
  img117,
  img118,
  img119,
  img120,
  img121,
  img122,
  img123,
  img124,
  img125,
];

export default imageSrcs;
